<template>
  <div class="index-cooperate">
    <h2>{{ element.titleBarName }}</h2>
    <template v-if="childItem.propsValue.data.length > 1">
      <div class="index-cooperate-tab">
        <div
          :class="'index-cooperate-tab-item' + (index == 0 ? ' active' : '')"
          v-for="(item, index) in childItem.propsValue.data"
          :key="index"
        >
          {{ item.customField1 }}
          <div v-if="index == 0" class="index-cooperate-line"></div>
        </div>
      </div>
    </template>
    <ul>
      <li v-for="(item, index) in childItem.propsValue.data[0].customField2" :key="index">
        <img class="logo-1" :src="item.customField4" />
        <span>{{ item.customField5 }}</span>
        <p>{{ item.customField6 }}</p>
        <img class="icon-1" src />
      </li>
    </ul>
    <ul class="index-cooperate-logos">
      <li
        class="index-cooperate-logo"
        v-for="(item, index) in childItem.propsValue.data[0].customField3"
        :key="index"
      >
        <img :src="item.customField8" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MkKehuanliPhone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "标题",
          type: "text"
        },
        {
          code: "customField2",
          label: "客户案例",
          type: "list",
          children: [
            {
              code: "customField4",
              label: "logo",
              type: "image",
              width: 330,
              height: 60
            },
            {
              code: "customField5",
              label: "标题",
              type: "text"
            },
            {
              code: "customField6",
              label: "描述",
              type: "text"
            },
            {
              code: "customField7",
              label: "落款",
              type: "text"
            }
          ]
        },
        {
          code: "customField3",
          label: "客户墙",
          type: "list",
          children: [
            {
              code: "customField8",
              label: "logo",
              type: "image",
              width: 220,
              height: 80
            }
          ]
        }
      ],
      data: [
        {
          customField1: "装备制造",
          customField2: [
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
              customField5: "中国国投：一级央企，以费用共享驱动整体财",
              customField6:
                "通过费控系统集成多家商旅，员工不借款及垫资，避免票据丢失及后续交单等相关业务。出差申请、商旅预定、商旅消费、商旅报销、统一结算、对公支付形成完整的管理闭环。通过差旅标准预置，从源头杜绝企业员工在出差过程中的超标行为。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU9_qAbyvbAAApmyXaz7U199.png",
              customField5: "福建冶控：省属国企，智能化填报与稽核助力管理升级",
              customField6:
                "全面实现全员智能填报。根据多种票据的采集方式，将原始的发票及票据形成账单数据，账单与消费类型进行自动关联。引导式填报、自动分解明细、自动计算补助，减少员工的填报时间。将企业财务常见的报销问题全部整合，企业可以按需启动规则，自动降低审核差错。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/08/7D/CgoRC2LU99yARVQLAAAsJoqjIUQ389.png",
              customField5: "碧桂园服务：全球最大物业集团，精细化费控管理",
              customField6:
                "报销制度融入系统控制规则、运用员工信用管理、费控智能化应用等，摸索出一套可复制成功经验，逐步推广到共享中心建设其他领域，比如应收共享的收款自动认领，应付共享的合同自动核对等。",
              customField7: ""
            }
          ],
          customField3: []
        },
        {
          customField1: "装备制造",
          customField2: [
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
              customField5: "中国国投：一级央企，以费用共享驱动整体财",
              customField6:
                "通过费控系统集成多家商旅，员工不借款及垫资，避免票据丢失及后续交单等相关业务。出差申请、商旅预定、商旅消费、商旅报销、统一结算、对公支付形成完整的管理闭环。通过差旅标准预置，从源头杜绝企业员工在出差过程中的超标行为。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU9_qAbyvbAAApmyXaz7U199.png",
              customField5: "福建冶控：省属国企，智能化填报与稽核助力管理升级",
              customField6:
                "全面实现全员智能填报。根据多种票据的采集方式，将原始的发票及票据形成账单数据，账单与消费类型进行自动关联。引导式填报、自动分解明细、自动计算补助，减少员工的填报时间。将企业财务常见的报销问题全部整合，企业可以按需启动规则，自动降低审核差错。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/08/7D/CgoRC2LU99yARVQLAAAsJoqjIUQ389.png",
              customField5: "碧桂园服务：全球最大物业集团，精细化费控管理",
              customField6:
                "报销制度融入系统控制规则、运用员工信用管理、费控智能化应用等，摸索出一套可复制成功经验，逐步推广到共享中心建设其他领域，比如应收共享的收款自动认领，应付共享的合同自动核对等。",
              customField7: ""
            }
          ],
          customField3: []
        },
        {
          customField1: "装备制造",
          customField2: [
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU986AXTW7AAAySaQCLGE206.png",
              customField5: "中国国投：一级央企，以费用共享驱动整体财",
              customField6:
                "通过费控系统集成多家商旅，员工不借款及垫资，避免票据丢失及后续交单等相关业务。出差申请、商旅预定、商旅消费、商旅报销、统一结算、对公支付形成完整的管理闭环。通过差旅标准预置，从源头杜绝企业员工在出差过程中的超标行为。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/00/CD/CgoRDGLU9_qAbyvbAAApmyXaz7U199.png",
              customField5: "福建冶控：省属国企，智能化填报与稽核助力管理升级",
              customField6:
                "全面实现全员智能填报。根据多种票据的采集方式，将原始的发票及票据形成账单数据，账单与消费类型进行自动关联。引导式填报、自动分解明细、自动计算补助，减少员工的填报时间。将企业财务常见的报销问题全部整合，企业可以按需启动规则，自动降低审核差错。",
              customField7: ""
            },
            {
              customField4:
                "https://mks.yybip.com/100x30/group1/M00/08/7D/CgoRC2LU99yARVQLAAAsJoqjIUQ389.png",
              customField5: "碧桂园服务：全球最大物业集团，精细化费控管理",
              customField6:
                "报销制度融入系统控制规则、运用员工信用管理、费控智能化应用等，摸索出一套可复制成功经验，逐步推广到共享中心建设其他领域，比如应收共享的收款自动认领，应付共享的合同自动核对等。",
              customField7: ""
            }
          ],
          customField3: []
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
/* 成长型建企 */
.index-cooperate {
  background-size: 100% 100%;
  .index-cooperate-tab {
    width: 100%;
    height: 30px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .index-cooperate-tab-item {
      padding: 5px 10px;
      .index-cooperate-line {
        margin-left: 10%;
        width: 80%;
        height: 2px;
        background-color: red;
      }
    }
    .active {
      color: red;
      font-weight: 500;
    }
  }
  .index-cooperate-logos {
    width: 375px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    .index-cooperate-logo {
      max-width: 170px;
      min-width: 170px;
      height: 40px;
      margin: 0;
      padding: 0;
      margin: 8px;
      img {
        width: 100%;
      }
    }
  }
}

.index-cooperate h2 {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #e31924;
  letter-spacing: 0;
  text-align: center;
  padding: 18px 0 13px 0;
}
.index-cooperate ul li {
  position: relative;
  background: #ffffff;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 13px 20px 13px;
  margin: 0 15px 15px;
}
.index-cooperate ul li .logo-1 {
  width: 57px;
}

.index-cooperate ul li span {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #707070;
  line-height: 16px;
  margin-bottom: 10px;
}
.index-cooperate ul li p {
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #707070;
  line-height: 15px;
}
</style>
